const menu_es={
    "button":{
	    "plans":"Planes",
	    "contact":"Entrar en contacto",
	    "learnMore":"Saber más"
    }
} 
export default menu_es
